// src/routes/ProtectedRoute.tsx
import LoadingScreen from "@/components/LoadingScreen";
import { useAuth } from "@/hooks/use-auth";
import { useVersionCheck } from "@/hooks/use-version-check";
import { redirectToCasLogin } from "@/lib/cas";
import { Navigate, Outlet } from "react-router";

interface ProtectedRouteProps {
  // Tambahkan tanda tanya (?) agar props ini tidak wajib diisi
  allowedRoles?: string[];
}

export default function ProtectedRoute({ allowedRoles }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();
  useVersionCheck();

  if (isLoading) {
    return (
      <LoadingScreen
        message="Memeriksa Hak Akses"
        subMessage="Mohon tunggu sebentar..."
        fullScreen={false}
      />
    );
  }

  // LAPIS 1: Cek Login (Berlaku untuk semua)
  if (!isAuthenticated || !user) {
    redirectToCasLogin();
    return null;
  }

  // LAPIS 2: Cek Role (Hanya jalan JIKA allowedRoles didefinisikan di router)
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return <Outlet />;
}
